import { QuestionMark } from "@phosphor-icons/react";
import { createColumnHelper } from "@tanstack/react-table";

import i18n from "@/i18n";
import type { Partner } from "@/types";
import { Circle } from "@/ui";
import { Badge } from "@/ui/Badge";

const columnHelper = createColumnHelper<Partner>();

export const getPartnersTableColumns = () => [
  columnHelper.accessor("name", {
    header: i18n.t("partner.name"),
    enableSorting: true,
    cell: (info) => {
      const { logo, name } = info.row.original;
      return (
        <div className="flex items-center gap-x-2">
          {logo ? (
            <img className="size-9" src={logo ?? ""} alt="partner" />
          ) : (
            <Circle className="bg-white">
              <QuestionMark size={24} className="text-primary-600" />
            </Circle>
          )}
          <span>{name}</span>
        </div>
      );
    },
  }),
  columnHelper.accessor("contact", {
    header: i18n.t("partner.main_contact"),
    enableSorting: true,
    cell: (info) => <span>{info.getValue()} </span>,
  }),
  columnHelper.accessor("type", {
    header: i18n.t("partner.type_of_partner"),
    enableSorting: true,
    cell: (info) => <span className="capitalize">{info.getValue()} </span>,
  }),
  columnHelper.display({
    id: "published",
    header: "Published",
    cell: (info) => {
      const published = info.row.original.published;
      return (
        <Badge
          text={published ? "Published" : "Draft"}
          className={
            published
              ? "bg-primary-800 text-primary-50"
              : "bg-neutral-300 text-neutral-950"
          }
        />
      );
    },
  }),
];
